export class ScreenSize {
    safeAreaTopHeight:number = 0;
    safeAreaBottomHeight:number = 0;
}